// extracted by mini-css-extract-plugin
module.exports = {"editDocumentWindowHeader":"editDocumentWindowHeader__S-uJg","modalTitle":"modalTitle__tl9Mu","text":"text__luGb4","switchButtons":"switchButtons__12Jnp"};